import React, { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
import { triggerNotification } from "../message/Msg";
import config from "../../config";
import AuthIllustration from "../../assetsCon/assets/img/illustrations/auth-login-illustration-light.png";
import maskImg from "../../assetsCon/assets/img/illustrations/auth-cover-login-mask-light.png";
import { Link } from "react-router-dom";
import ForgotPassTchr from "./ForgotPassTchr";
import MediaPopup from "../mediapopup/MediaPopup";

const RegistrationTeacher = (props) => {
  //-------------------------------- state manager --------------------------------------

  const [formData, setFormData] = useState({
    fname: "",
    lname: "",
    email: "",
    mobileno: "",
    address: "",
    gender: "",
    dob: "",
    isTPT: "1",
    from: "0",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // --------------------------------------- submit form -----------------------------------C--U
  const handleCreateTeacher = async (e) => {
    e.preventDefault();

    // --- Require field validation ---
    if (
      !formData.fname.trim() ||
      !formData.lname.trim() ||
      !formData.email.trim() ||
      !formData.mobileno.trim() ||
      !formData.address.trim()
    ) {
      triggerNotification("error", "Input fields cannot be empty!!");
      return; // Stop form submission
    } else if (!formData.gender.trim() || !formData.dob.trim()) {
      triggerNotification("error", "Please select date and gender!!");
      return; // Stop form submission
    }

    // --- Email validation ---
    const validateEmail = (email) => {
      const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
      return emailRegex.test(email);
    };

    if (!validateEmail(formData.email)) {
      triggerNotification("error", "Please enter a valid email address");
      return; // Stop form submission
    }

    // Call the API to create a teacher with formData
    try {
      await fetch(`${config.host_url}teacher`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.status === 200) {
            triggerNotification("success", `Teacher Signup Successfully.`);
            setFormData({
              fname: "",
              lname: "",
              email: "",
              mobileno: "",
              address: "",
              gender: "",
              dob: "",
              isTPT: "1",
              from: "0",
            });
            props.regi(false);
          } else if (data.status === 400) {
            // Handle validation errors if any
            const errorMsgs = Array.isArray(data.msg)
              ? data.msg.join(", ")
              : data.msg;
            console.log("Error: ", errorMsgs);
            triggerNotification(
              "error",
              errorMsgs
                ? errorMsgs
                : "Some Error Occur!! Please sign up After Some Time (Er: 400)"
            );
          } else if (data.status === 401) {
            triggerNotification("error", "Unauthenticated user!");
          } else {
            triggerNotification("error", "Internal Server Error");
          }
        });
    } catch (error) {
      triggerNotification(
        "error",
        "Some Error Occurred!! Please try again later"
      );
    }
  };

  return (
    <>
      <div className="w-px-600 mx-auto  pt-lg-0">
        <div className="app-brand justify-content-center mt-3">
          <img
            className="app-brand-text demo text-heading fw-bold w-48 "
            src="https://deepvecto.com/wp-content/uploads/2023/09/Deepvecto_Logo.png"
          />
        </div>
        <div className="mt-4">
          <h4 className="mb-6 text-center">Deepvecto TPT Registration! 👋</h4>
          <form>
            <div className="row">
              <div className="col-md-6">
                {/* Teacher fname */}
                <div className="form-floating form-floating-outline mb-4">
                  <input
                    type="text"
                    className="form-control"
                    name="fname"
                    id="fname"
                    placeholder="First Name"
                    value={formData.fname}
                    onChange={handleChange}
                    autoFocus
                  />
                  <label htmlFor="fname"> First Name</label>
                </div>
              </div>
              <div className="col-md-6">
                {/* Teacher lname */}
                <div className="form-floating form-floating-outline mb-4">
                  <input
                    type="text"
                    className="form-control"
                    name="lname"
                    id="lname"
                    placeholder="Last Name"
                    value={formData.lname}
                    onChange={handleChange}
                  />
                  <label htmlFor="lname">Last Name</label>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                {/* Mobile Number */}
                <div className="form-floating form-floating-outline mb-4">
                  <input
                    type="number"
                    className="form-control"
                    name="mobileno"
                    id="mobileno"
                    placeholder="Mobile Number"
                    value={formData.mobileno}
                    onChange={handleChange}
                  />
                  <label htmlFor="mobileno">Mobile Number</label>
                </div>
              </div>
              {/* Email */}
              <div className="col-md-6">
                <div className="form-floating form-floating-outline mb-4">
                  <input
                    type="text"
                    className="form-control"
                    name="email"
                    id="email"
                    placeholder="Email"
                    value={formData.email}
                    onChange={handleChange}
                  />
                  <label htmlFor="email">Email</label>
                </div>
              </div>
            </div>
            {/* Address */}
            <div className="form-floating form-floating-outline mb-4">
              <input
                type="text"
                className="form-control"
                name="address"
                id="address"
                placeholder="Address"
                value={formData.address}
                onChange={handleChange}
              />
              <label htmlFor="address">Address</label>
            </div>

            {/* gender | dob */}
            <div className="row">
              <div className="col-md-6">
                {/* Gender */}
                <div className="form-floating form-floating-outline mb-4">
                  <select
                    className="form-select"
                    name="gender"
                    id="gender"
                    aria-label="Select Gender"
                    value={formData.gender}
                    onChange={handleChange}
                  >
                    <option value="" disabled selected>
                      Select Gender
                    </option>
                    <option value="male">Male</option>
                    <option value="female">Female</option>
                    <option value="other">Other</option>
                  </select>
                  <label htmlFor="gender">Gender</label>
                </div>
              </div>
              <div className="col-md-6">
                {/* Date Of Birth */}
                <div className="form-floating form-floating-outline mb-4">
                  <input
                    type="date"
                    className="form-control"
                    name="dob"
                    id="dob"
                    placeholder="Date Of Birth"
                    value={formData.dob}
                    onChange={handleChange}
                  />
                  <label htmlFor="dob">Date Of Birth</label>
                </div>
              </div>
            </div>

            {/* Sign Up */}
            <div className="mt-3 ">
              <div className="">
                <button
                  type="button"
                  className="btn btn-primary d-grid w-100"
                  onClick={handleCreateTeacher}
                >
                  Sign Up
                </button>
              </div>
            </div>
          </form>

          <hr />
          <p className="text-center ">
            <span>Already have an account? </span>

            <span
              className="text-[#7579FF]"
              onClick={() => {
                props.regi(false);
              }}
            >
              Login instead
            </span>
          </p>
        </div>
      </div>
    </>
  );
};

export default RegistrationTeacher;
